module.exports = __webpack_public_path__ + "static/media/comment-chart-line.0fe81fdd.svg";